import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/api-explorer',
    component: ComponentCreator('/api-explorer', 'e8e'),
    exact: true
  },
  {
    path: '/auth',
    component: ComponentCreator('/auth', '85d'),
    exact: true
  },
  {
    path: '/callback',
    component: ComponentCreator('/callback', '4e6'),
    exact: true
  },
  {
    path: '/dashboard',
    component: ComponentCreator('/dashboard', 'd63'),
    exact: true
  },
  {
    path: '/endpoint',
    component: ComponentCreator('/endpoint', 'dce'),
    exact: true
  },
  {
    path: '/search',
    component: ComponentCreator('/search', '822'),
    exact: true
  },
  {
    path: '/updates',
    component: ComponentCreator('/updates', 'f29'),
    exact: true
  },
  {
    path: '/',
    component: ComponentCreator('/', 'e5f'),
    exact: true
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
